import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "Qu'est-ce qu'une étude de sol G1, G2, G3, G4 ou G5 ?",
    a: "Ce sont les missions géotechniques normalisées par la norme NF P 94-500. La G1 est l'étude préalable de site, qui identifie les risques majeurs avant achat ou conception. La G2 (avant-projet puis projet) dimensionne précisément les fondations adaptées à votre maison. La G3 assure l'étude et le suivi d'exécution sur le chantier. La G4 est la supervision géotechnique de la phase travaux. Enfin la G5 traite un diagnostic spécifique sur un ouvrage existant. À La Réunion, la G2 est la mission la plus fréquemment demandée par les assureurs et les banques avant un permis de construire.",
  },
  {
    q: "Combien de temps pour obtenir un permis de construire à La Réunion ?",
    a: "Le délai d'instruction légal est de 2 mois pour une maison individuelle et de 3 mois pour les autres projets, à compter du dépôt en mairie. À cela il faut ajouter le délai de conception du dossier (généralement 4 à 6 semaines chez Solmis Habitat) et un éventuel délai de demande de pièces complémentaires par le service urbanisme. Comptez en moyenne 3 à 5 mois entre le premier rendez-vous et l'obtention du permis. Nous assurons le suivi auprès de la mairie jusqu'à la délivrance officielle.",
  },
  {
    q: "Quel est le coût d'une étude de sol à La Réunion ?",
    a: "Le coût varie selon la mission (G1, G2, G3…), la surface du terrain, son accessibilité et la nature géologique du sol (basalte, argile, scories volcaniques). Une étude G2 standard sur une parcelle plate accessible est généralement bien moins onéreuse qu'une G2 sur terrain en pente dans les hauts. Solmis Habitat propose un devis personnalisé gratuit et sans engagement, avec un tarif transparent fourni avant toute intervention de notre partenaire technique Innocean.",
  },
  {
    q: "Intervenez-vous sur toute l'île de La Réunion ?",
    a: "Oui, Solmis Habitat accompagne les projets sur l'ensemble du territoire réunionnais (974) : côte Ouest (Saint-Paul, Saint-Leu, L'Étang-Salé), Sud (Saint-Pierre, Le Tampon, Petite-Île, Saint-Joseph, Saint-Philippe), Est (Saint-Benoît, Sainte-Rose, Saint-André), Nord (Saint-Denis, Sainte-Marie, Sainte-Suzanne) et hauts inclus (Cilaos, Salazie, L'Entre-Deux, Plaine-des-Cafres). Nous maîtrisons les spécificités des PLU communaux locaux et les contraintes géologiques propres à chaque zone.",
  },
  {
    q: "Mon terrain est en zone volcanique ou à risque, est-ce un problème ?",
    a: "Pas nécessairement. La Réunion comporte de nombreuses zones avec contraintes spécifiques (coulées récentes du Tampon ou de Saint-Philippe, zones argileuses, terrains en pente forte, aléa mouvement de terrain dans les hauts). L'étude de sol G2 permet précisément d'identifier ces contraintes et de dimensionner des fondations adaptées (semelles renforcées, pieux, longrines). Avec un dossier technique solide, la quasi-totalité des terrains réunionnais sont constructibles — il faut juste les bonnes solutions.",
  },
  {
    q: "Quelle est la différence entre un permis de construire et une déclaration préalable ?",
    a: "La déclaration préalable de travaux (DP) suffit pour les petits projets : extension de moins de 20 m² (ou 40 m² en zone urbaine couverte par un PLU), abri de jardin, modification de façade, ravalement. Le permis de construire (PC) devient obligatoire au-delà de ces seuils, pour toute construction neuve, ou pour les changements de destination avec travaux. À La Réunion, la majorité des projets de maisons individuelles et d'extensions significatives relèvent du PC. Nous vous orientons gratuitement vers la bonne procédure dès l'analyse initiale.",
  },
  {
    q: "Puis-je faire uniquement l'étude de sol ou uniquement le permis ?",
    a: "Absolument. Solmis Habitat propose des prestations modulaires : étude de sol seule (G1, G2 ou G3 via Innocean), dossier de permis de construire seul, ou pilotage projet seul. Vous pouvez aussi opter pour notre accompagnement complet de A à Z, qui regroupe étude de sol, conception du dossier, dépôt en mairie, suivi de l'instruction et coordination avec les artisans. Le devis est toujours personnalisé selon votre périmètre.",
  },
  {
    q: "Combien de temps pour un permis de construire instruit en mairie ?",
    a: "Le délai légal d'instruction démarre dès la réception en mairie du dossier complet. Il est de 2 mois pour une maison individuelle et ses annexes, et de 3 mois pour les autres constructions ou pour les projets situés dans une zone protégée. En cas de demande de pièces complémentaires par le service urbanisme, le délai est suspendu jusqu'à fourniture des éléments. Certaines communes réunionnaises (Saint-Denis, Saint-Pierre) ont des délais effectifs proches du légal, d'autres peuvent être un peu plus longs en période chargée.",
  },
  {
    q: "Qu'est-ce que le PLU et comment ça affecte mon projet à La Réunion ?",
    a: "Le Plan Local d'Urbanisme (PLU) est le document de référence qui fixe, commune par commune, les règles de constructibilité : zonage (zones U urbaines, AU à urbaniser, A agricoles, N naturelles), hauteur maximale, emprise au sol, recul par rapport aux limites, COS éventuel, prescriptions architecturales et paysagères. Chaque commune de La Réunion a son propre PLU (parfois récent et strict). Avant tout projet, nous analysons gratuitement le règlement applicable à votre parcelle pour vérifier sa faisabilité.",
  },
  {
    q: "Votre devis est-il vraiment gratuit et sans engagement ?",
    a: "Oui, à 100 %. Le premier échange (téléphone, WhatsApp ou rendez-vous), l'analyse initiale du projet, la vérification du PLU et le devis détaillé sont totalement gratuits et ne vous engagent à rien. Vous recevez une proposition transparente sous 24 à 48h ouvrées, que vous êtes libre d'accepter, de refuser ou de comparer. Nous facturons uniquement après votre accord écrit.",
  },
];

export default function FAQ() {
  return (
    <section id="faq" data-testid="faq-section" className="py-24 md:py-32">
      <div className="container-narrow">
        <div className="grid md:grid-cols-12 gap-12 items-start">
          <div className="md:col-span-5 reveal">
            <div className="flex items-center gap-3 mb-6">
              <span className="rule" />
              <span className="overline">Questions</span>
            </div>
            <h2 className="text-4xl sm:text-5xl font-medium leading-tight text-primary">
              Tout{" "}
              <span className="italic font-light">ce que</span> vous devez
              savoir.
            </h2>
            <p className="mt-5 text-sm text-muted-foreground">
              Une question qui ne figure pas ici ? Appelez-nous, nous y
              répondons volontiers.
            </p>
          </div>

          <div className="md:col-span-7 reveal">
            <Accordion
              type="single"
              collapsible
              className="border-t border-border"
            >
              {faqs.map((f, i) => (
                <AccordionItem
                  key={f.q}
                  value={`item-${i}`}
                  data-testid={`faq-item-${i}`}
                  className="border-b border-border"
                >
                  <AccordionTrigger className="py-6 text-left font-display text-xl md:text-2xl text-primary hover:no-underline">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="pb-6 text-base leading-relaxed text-muted-foreground">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
}
